export default __webpack_public_path__ + "static/media/person3.2c39f2cd.jpg";